import React from 'react'
import { useEffect,useState } from 'react'
import FormSelect from '../../../../components/forms/formSelect';
import GreenButton from '../../../../components/forms/greenButton';
import ApiUrl from '../../../../configTools/apiUrl';

const Addnewparent = ({allcategoryList,getSearchScreens}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [typelist, setTypeList] = useState([{name:'Collection', value:'1'},{name:'Hashtag', value:'2'}]);
    const [type,setType] = useState({name:'Collection', value:'1'});
    const [parentCollections, setParentCollections] = useState([]);
    const [category,setCategory] = useState({name:'Select', value:'0'});
    const add = ()=>{
        if(category.value === '0'){
          return;
        }
        fetch(ApiUrl.API_URL_SearchScreen, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
              collection: parseInt(category.value),
              type:parseInt(type.value)
            })
            })
            .then(res=>res.json())
            .then(data =>{
            if(data.success){
              alert('added');
                getSearchScreens();
            }
            else{
                alert("Category already exist.");
            }
            });
    }
    useEffect(()=>{
      if(type.value !== '1'){
        setType({name:'Collection', value:'1'});
      }
        let collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === 0){
            collectionListSend.push({
                name: element.title,
                value: String(element.id)
            })
          }
        }
        setParentCollections(collectionListSend);
    },[allcategoryList])
    useEffect(()=>{
      setCategory({name:'Select', value:'0'});
      if(type.value === '1'){
        let collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === 0){
            collectionListSend.push({
                name: element.title,
                value: String(element.id)
            })
          }
        }
        setParentCollections(collectionListSend);
      }
      else{
        fetch(ApiUrl.API_URL_Intrust)
        .then(res=>res.json())
        .then(data =>{
          let collectionListSend = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            collectionListSend.push({
                name: element.name,
                value: String(element.id)
            })
          }
          setParentCollections(collectionListSend);
        });
      }
    },[type])
  return (
    <div className='admin_forms_container'>
      <div className='iossearch_add_new_container'>
        <div className='iossearch_add_new_collection'>
            <FormSelect Lable='Type' Value={type} setValue={setType} Options={typelist}/>
        </div>
        <div className='iossearch_add_new_collection'>
            <FormSelect Lable={type.value === '1'?'Category':'Hashtags'} Value={category} setValue={setCategory} Options={parentCollections}/>
        </div>
        <div className='iossearch_add_button'>
            <GreenButton Value={"Add"} Action={add}/>
        </div>
      </div>
    </div>
  )
}

export default Addnewparent
